import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

const GET_PROJECT_FILE = gql`
  query GetProjectFile($projectFileId: ID!) {
    getProjectFile(projectFileId: $projectFileId) {
      _id
      name
      description
      style
      projectCategory
      projectStyle
      specialRequirements
      budgetRange
      squareFootage
      projectDuration
      published
      images {
        url
        path
        _id
        title
        credit
        description
      }
    }
  }
`;

export const useGetProjectFileQuery = () => {
  const [getProjectFileQuery, { loading, data }] =
    useLazyQuery(GET_PROJECT_FILE);

  const getProjectFile = useCallback(async (
    projectFileId: string,
    refresh: boolean = false
  ) => {
    const result = await getProjectFileQuery({
      variables: {
        projectFileId,
      },
      fetchPolicy: refresh ? "network-only" : "cache-first",
    });
    return result?.data?.getProjectFile;
  }, [getProjectFileQuery]);

  const projectFile = data?.getProjectFile;

  return {
    getProjectFile,
    loading,
    projectFile,
  };
};
